export const pokemonlegends = `アヤシシ
バサギリ
ガチグマ
イダイトウ
オオニューラ
ハリーマン
ラブトロス`;
